/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './ProManage.css';
import WhereField from './partials/WhereField';
import LocationForm from './partials/LocationForm';
import LeaderboardStats from './partials/LeaderboardStats';
import RegisterForm from './partials/RegisterForm';
import CompanySignUpForm from './partials/CompanySignUpForm';
import OzModalButton from './partials/OzModalButton';
import DeleteRoomForm from './partials/DeleteRoomForm';
import MarkDuplicateForm from './partials/MarkDuplicateForm';
import {
  register,
  fetchUser,
  companySignUp,
  listCompanies,
  addLocation,
  getCompany,
  updateRoom,
  updateLocation,
  markDupes,
} from '../actions';


class ProLocation extends Component {
  state = {};

  deleteHide(e, room, values) {
    this.props.updateRoom(room.id, values)
      .then(resp => {
        if (resp.error) return;
        this.props.refresh()
          .then(() => this.setState({ deleting: false }));
      });
  }

  markDupes(e, values) {
    this.props.markDupes(values)
      .then(resp => {
        if (resp.error) return;
        this.setState({ markingDupe: false });
        this.props.refresh()
          .then(() => NotificationManager.success('Marked duplicates'));
      });
  }

  saveLocation(e, values) {
    console.log('save location:', values);
    this.props.updateLocation(this.state.editingLocationId, values)
      .then(resp => {
        console.log('save resp:', resp);
        if (resp.error) return;

        this.props.refresh()
          .then(() => {
            this.setState({ editingLocationId: false });
          });
      });
  }

  renderDeleteNode(room) {
    return (
      <OzModalButton
        modalTitle={'Hide ' + room.name}
        show={this.state.deleting == room.id}
        onShow={() => this.setState({ deleting: room.id })}
        onHide={() => this.setState({ deleting: false })}
        >

        <div>{room.disabled ? 'Unhide' : 'Hide'}</div>

        <DeleteRoomForm
          modal={true}
          values={{}}
          errors={this.props.errors.deleteRoom}
          onCancel={() => this.setState({ deleting: false })}
          onSubmit={(e, values) => this.deleteHide(e, room, values)}
          buttonText="Hide"
          cancelText="Cancel"
        />
      </OzModalButton>
    );
  }

  renderMarkDuplicateNode(room) {
    return (
      <OzModalButton
        modalTitle={'Mark as Duplicate'}
        show={this.state.markingDupe == room.id}
        onShow={() => this.setState({ markingDupe: room.id })}
        onHide={() => this.setState({ markingDupe: false })}
        >

        <div>Mark as Dupe</div>

        <MarkDuplicateForm
          modal={true}
          values={{ roomId: room.id }}
          errors={this.props.errors.markDuplicate}
          onCancel={() => this.setState({ markingDupe: false })}
          onSubmit={(e, values) => this.markDupes(e, values)}
          buttonText="Mark as Duplicate"
          cancelText="Cancel"
          room={room}
        />
      </OzModalButton>
    );
  }

  render() {
    let location = this.props.location;
    console.log('pro location', location);

    let nodes = location.rooms.map(room => {
      if (room.disabled) return;
      let viewUrl = '/r/' + room.slug + '/' + room.id;
      return (
        <div key={room.id} className="room">
          <div className="name-wrapper">
            <div className="name"><Link to={'/pro/rooms/' + room.id}>{room.name}</Link></div>
            <div className="controls">
              <div className="control"><Link to={viewUrl}>View On Site</Link></div>
              <div>&middot;</div>
              <div className="control">{this.renderDeleteNode(room)}</div>
              <div>&middot;</div>
              <div className="control">{this.renderMarkDuplicateNode(room)}</div>
            </div>
          </div>
          <Link to={'/pro/rooms/' + room.id}><Button bsSize="small">Edit</Button></Link>
          <Link to={'/pro/rooms/' + room.id + '?tab=leaderboard'}><Button bsSize="small" bsStyle="primary">Leaderboard</Button></Link>
        </div>
      );
    });

    let disabledCount = 0;
    let disabledNodes = location.rooms.map(room => {
      if (!room.disabled) return;
      disabledCount++;
      return (
        <div key={room.id} className="room">
          <div className="name-wrapper">{room.name}</div>
          <Button bsSize="small">{this.renderDeleteNode(room)}</Button>
        </div>
      );
    });

    return (
      <div className="ProLocation">
        <div className="location-header">
          <div className="location-address">
            {location.address}
          </div>
          <div className="controls">
            <OzModalButton
              modalTitle="Edit Location"
              show={this.state.editingLocationId}
              onShow={() => this.setState({ editingLocationId: true })}
              onHide={() => this.setState({ editingLocationId: false })}
              >
              <Button>Edit Location</Button>

              <LocationForm
                modal={true}
                values={location}
                errors={this.props.errors.location}
                onCancel={() => this.setState({ editingLocationId: false })}
                onSubmit={(e, values) => this.saveLocation(e, values)}
                buttonText="Save"
                cancelText="Cancel"
              />
            </OzModalButton>
            {' '}
            <Link to={'/pro/rooms/add?location=' + location.id}><Button>Add Room</Button></Link>
          </div>
        </div>

        <div className="location-rooms">
          {nodes}
        </div>

        {disabledCount > 0 && <div className="location-rooms-header">Hidden rooms</div>}
        {disabledCount > 0 && <div className="location-rooms">
          {disabledNodes}
        </div>}
      </div>
    );
  }
}


class ProCompany extends Component {
  state = {};

  refreshCompany() {
    return this.props.listCompanies({ mine: 1 });
  }

  addLocation(e, values) {
    console.log('add location:', values);
    values.companyId = this.props.company.id;
    this.props.addLocation(values)
      .then(resp => {
        console.log('add location resp', resp);
        this.refreshCompany()
          .then(() => {
            this.setState({ addingLocation: false });
          });
      });
  }

  render() {
    let company = this.props.company;

    let nodes = company.locations.map(location => <ProLocation
                                                    key={location.id}
                                                    location={location}
                                                    errors={this.props.errors}
                                                    updateRoom={this.props.updateRoom}
                                                    updateLocation={this.props.updateLocation}
                                                    markDupes={this.props.markDupes}
                                                    refresh={this.props.refresh}
                                                  />);

    return (
      <div className="ProCompany">
        <div className="company-header">
          <div className="company-name"></div>

          <div className="controls">
            <OzModalButton
              modalTitle="Add Location"
              show={this.state.addingLocation}
              onShow={() => this.setState({ addingLocation: true })}
              onHide={() => this.setState({ addingLocation: false })}
            >
              <Button>Add Location</Button>

              <LocationForm
                modal={true}
                values={{}}
                errors={this.props.errors.location}
                onCancel={() => this.setState({ addingLocation: false })}
                onSubmit={(e, values) => this.addLocation(e, values)}
                buttonText="Add Location"
                cancelText="Cancel"
                noRegions
              />
            </OzModalButton>
          </div>
        </div>

        <div className="company-locations">{nodes}</div>
      </div>
    );
  }
}


class ProManage extends OzComponent {

  static need = [
    ['user', fetchUser],
  ]

  state = {};

  componentDidMount() {
    this.props.listCompanies({ mine: 1 });
  }

  refresh() {
    return this.props.listCompanies({ mine: 1 }, { background: true });
  }

  renderCompanies() {
    let companies = this.props.companies;
    if (!companies) return;

    let nodes = companies.items.map(company => <ProCompany
                                                 key={company.id}
                                                 company={company}
                                                 errors={this.props.errors}
                                                 addLocation={this.props.addLocation}
                                                 getCompany={this.props.getCompany}
                                                 updateRoom={this.props.updateRoom}
                                                 updateLocation={this.props.updateLocation}
                                                 markDupes={this.props.markDupes}
                                                 refresh={() => this.refresh()}
                                               />);

    return (
      <div className="companies">
        {nodes}
      </div>
    );
  }

  render() {
    return (
      <Wrapper className="ProManage" pro>
        <Helmet>
          <title>Manage Listings - EscapeSpy</title>
        </Helmet>

        <div className="pro-header">Manage Your Rooms</div>

        {this.renderCompanies()}
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
    companies: state.list.company,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    register,
    fetchUser,
    companySignUp,
    listCompanies,
    addLocation,
    getCompany,
    updateRoom,
    updateLocation,
    markDupes,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProManage);



/** WEBPACK FOOTER **
 ** ./src/components/ProManage.js
 **/